import React from "react";
import { SALES_EMAIL, useContent } from "./content";
import { useHomeLang } from "./homeLang";
import "./networks.css";

const WORDS = {
  it: { heading: "Una sola voce per la Rete. Il volto di ogni consulente.", ask: "Parliamo della vostra Rete.", contact: "Contattaci" },
  en: { heading: "One voice for the network. The face of every advisor.", ask: "Let’s talk about your network.", contact: "Contact us" },
};

// For networks and banks: the promise and what it is made of, in a raised
// panel.
export default function NetworksSection() {
  const { NETWORK_POINTS } = useContent();
  const words = WORDS[useHomeLang()];
  return (
    <section id="reti" aria-labelledby="hf-h-nets" className="hf-sec hf-wrap">
      <div className="nw">
        <div className="nw-claim">
          <h2 id="hf-h-nets" className="t-h2">{words.heading}</h2>
          <div className="nw-act">
            <p className="t-body nw-ask">{words.ask}</p>
            <a className="btn btn-quiet" href={`mailto:${SALES_EMAIL}`}>{words.contact}</a>
          </div>
        </div>
        <ul className="nw-points">
          {NETWORK_POINTS.map(([title, body]) => (
            <li key={title}>
              <h3 className="t-h3">{title}</h3>
              <p className="t-body">{body}</p>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
